import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import { setProtocolIntegrations } from 'actions/protocols/integrations';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { GetFromCtxValue } from 'helpers';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { CanUserEditIntegration } from 'appconstants/Permission';
import PropTypes from 'prop-types';
import ViewIntegrationInfo from './ViewIntegrationInfo';
import EditIntegrationInfo from './EditIntegrationInfo';

const IntSummary = (props) => {
  const {
    intInfo, prtDetails, state, setState, activationDate, onSaveIntegrations, toggleIntegrations
  } = props;

  useEffect(() => {
    setState(false);
  }, [prtDetails, setState]);

  return (
    <RenderEditable
      state={state}
      editable={CanUserEditIntegration()}
      setState={setState}
      title="Integration Information"
    >
      <RenderElement access={state === true}>
        <EditIntegrationInfo
          intInfo={intInfo}
          saveIntegrationInfo={onSaveIntegrations}
          closeIntegrations={toggleIntegrations}
          activationDate={activationDate}
        />
      </RenderElement>
      <RenderElement access={state === false}>
        <ViewIntegrationInfo intInfo={intInfo} />
      </RenderElement>
    </RenderEditable>
  );
};


IntSummary.propTypes = {
  intInfo: PropTypes.oneOfType([PropTypes.object]),
  prtDetails: PropTypes.oneOfType([PropTypes.object]),
  activationDate: PropTypes.string,
  onSaveIntegrations: PropTypes.func,
  toggleIntegrations: PropTypes.func
};

IntSummary.defaultProps = {
  intInfo: null,
  prtDetails: null,
  activationDate: '',
  onSaveIntegrations: null,
  toggleIntegrations: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    prtDetails: state.prtDetails,
    activationDate: state.prtDetails.prtInfo.grpProtStatusDate
  }),
  dispatch => bindActionCreators(
    {
      onSetProtocolIntegrations: setProtocolIntegrations
    },
    dispatch
  )
);

const integrationSummary = compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withHandlers({
    toggleIntegrations: props => event => {
      const { setState, state } = props;
      setState(!state);
    }
  }),
  withHandlers({
    onSaveIntegrations: props => (intInfo) => {
      const {
        context,
        selectedProt,
        toggleIntegrations,
        onSetProtocolIntegrations
      } = props;
      bindLogger(onSetProtocolIntegrations, context)(
        selectedProt,
        intInfo
      ).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: GetFromCtxValue(context, 'PROTOCOL_INTEGRATION_SUCCESS'),
            variant: 'success',
            name: 'integration'
          });
          toggleIntegrations();
        }
      });
    }
  })
)(IntSummary);

const IntegrationSummary = withAppContext(integrationSummary);
export default IntegrationSummary;
